import { Grid } from "@material-ui/core";
import React, { useContext, useEffect } from "react";
import AccordionNav from "../../components/common/AccordionNav";
import UserContext from "../../context/user-context";
import { useStore } from "../../hooks/useStore";
import { useTranslation } from "../../hooks/useTranslation";
import User from "../../passapp-sdk/user";
import { addAuthorization } from "../../store/actions/userAction";
import { convertAuthorization } from "../../store/functions/userFunction";
import { AuthorizationType } from "../../store/types/userTypes";
import { AwaitingRequestAuthorization } from "./AwaitingRequestAuthorization/AwaitingRequestAuthorization";
import { CurrentAuthorization } from "./CurrentAuthorizations/CurrentAuthorization";
import { GuardAuthorization } from "./GuardAuthorization/GuardAuthorization";
import { LastEntranceAuthorization } from "./LastEntranceAuthorization/LastEntranceAuthorization";
import SearchAuthorizations from "./SearchAuthorizations/SearchAuthorizations";
type AuthorizationProps = {
  companion?: boolean;
};
const Authorizations = ({ companion }: AuthorizationProps) => {
  const { state, dispatch } = useContext(UserContext);
  const { authStore } = useStore();
  const { t, BundleKey } = useTranslation();
  const user = new User();

  const addAuthorizationState = (
    data: any,
    options?: {
      type?: AuthorizationType;
      mark?: boolean;
      hidden?: boolean;
    }
  ) => {
    dispatch(addAuthorization(convertAuthorization(data, options)));
  };

  const updateAuthorizations = async () => {
    user
      .getLastEntrance(
        authStore.token,
        state.id,
        state.dni,
        state.countryCode,
        true
      )
      .then((response: any) => {
        if (response.data.event) {
          response.data.event.invites?.forEach((item: any) => {
            addAuthorizationState(item, {
              type: AuthorizationType.lastEntrance,
            });
          });
          response.data.event.authorizations?.forEach((item: any) => {
            addAuthorizationState(item, {
              type: AuthorizationType.lastEntrance,
            });
          });
          response.data.event.hostConfirmations?.forEach((item: any) => {
            addAuthorizationState(
              { host: item, id: item.id, type: "resident" },
              {
                type: AuthorizationType.lastEntrance,
              }
            );
          });
          response.data.event.lots?.forEach((item: any) => {
            addAuthorizationState(
              {
                host: {
                  id: item.id,
                  customLot: item.name,
                  residencesInfo: [
                    {
                      lotInfo: {
                        id: item.id,
                        name: item.name,
                        description: item.description,
                        phone: item.phone,
                      },
                    },
                  ],
                },
                id: item.id,
              },
              { type: AuthorizationType.lastEntrance }
            );
          });
        }
      })
      .finally(() => {
        user
          .getAuthorizations(authStore.token, state.dni, state.countryCode)
          .then((response) => {
            if (response.data.authorizations.length !== 0) {
              response.data.authorizations?.forEach((item: any) => {
                addAuthorizationState(item, {
                  type: AuthorizationType.current,
                });
              });
            }
            if (response.data.invites?.length !== 0) {
              response.data.invites?.forEach((item: any) => {
                if (item.type === "invite") {
                  addAuthorizationState(item, {
                    type: AuthorizationType.current,
                    mark: state.isPass === item.id || false,
                  });
                }
                if (item.type === "request") {
                  addAuthorizationState(item, {
                    type: AuthorizationType.awaitingRequest,
                  });
                }
              });
            }
          });
        if (state.isResident) {
          addAuthorizationState(
            {
              host: state,
              id: state.id,
              type: "resident",
            },
            {
              mark: true,
              type: AuthorizationType.current,
            }
          );
        }
      });
  };

  useEffect(() => {
    if (state.config?.eventType === "in" || state.config?.companion) {
      updateAuthorizations();
    }
  }, []);
  return (
    <AccordionNav title={t(BundleKey.DETAIL_AUTHORIZATION_TITLE)}>
      <Grid container>
        <Grid item xs={12}>
          <SearchAuthorizations />
        </Grid>
        <Grid item xs={12}>
          <CurrentAuthorization />
        </Grid>
        <Grid item xs={12}>
          <GuardAuthorization />
        </Grid>
        <Grid item xs={12}>
          <AwaitingRequestAuthorization />
        </Grid>
        <Grid item xs={12}>
          <LastEntranceAuthorization />
        </Grid>
      </Grid>
    </AccordionNav>
  );
};
export default Authorizations;
